module.exports = __webpack_public_path__ + "static/img/Tom-Gilbert.f03a3ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-Gilbert.jpg
// module id = J/Zf
// module chunks = 0